import {
  type AgenticLogicSurface,
  agenticLogicSurfaceFromDescriptor,
} from "@src/features/ai/pages/agentic-logic/surface/surface";
import { useSelector } from "@src/store";
import { getActiveAgenticLogicSurface } from "@src/store/slices/global";

/**
 * The agentic-logic surface currently on screen, for consumers that live
 * OUTSIDE the page tree and so cannot read the context — chiefly the chat rail,
 * which navigates to a rule it has just created.
 *
 * Null when no surface is mounted. Callers inside the page tree should use
 * `useAgenticLogicSurface`, which is never null.
 */
export const useActiveAgenticLogicSurface = (): AgenticLogicSurface | null => {
  const descriptor = useSelector(getActiveAgenticLogicSurface);
  return descriptor ? agenticLogicSurfaceFromDescriptor(descriptor) : null;
};
